// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D0Da","colBig":"styles_colBig__1mAeK","colSmall":"styles_colSmall__2RULk"};